/**
 * @generated SignedSource<<3604f42dc24714f8530849e144d5f61a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksUseDynamicMetaTags$data = {
  readonly metatags: ReadonlyArray<{
    readonly key: string | null;
    readonly value: string | null;
  } | null> | null;
  readonly " $fragmentType": "hooksUseDynamicMetaTags";
};
export type hooksUseDynamicMetaTags$key = {
  readonly " $data"?: hooksUseDynamicMetaTags$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUseDynamicMetaTags">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksUseDynamicMetaTags",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "KeyValuePair",
      "kind": "LinkedField",
      "name": "metatags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DynamicMetaTags",
  "abstractKey": "__isDynamicMetaTags"
};

(node as any).hash = "bac39c7e3441f446b6cda383defd2361";

export default node;
